import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { startCDNTestRequest } from '@/store/scorm/action';
import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';

const ScormCDNTest: React.FC = () => {
    const dispatch = useDispatch();

    const { cdnTestUrl } = useSelector((state: ApplicationState) => ({
        cdnTestUrl: state.scorm.data,
    }));

    const [cookies, setCookie] = useCookies([Constants.scormCdnTest.COOKIE_NAME]);

    useEffect(() => {
        if (!cookies[Constants.scormCdnTest.COOKIE_NAME]) {
            dispatch(startCDNTestRequest());
        }
    }, [dispatch]);

    const handlerMessage = (e: MessageEvent) => {
        if (e.data === 'CDN_TEST_PASSED') {
            setCookie(Constants.scormCdnTest.COOKIE_NAME, Constants.scormCdnTest.PASSED, { path: '/', maxAge: 60 * 60 * 24 * 7 });
        } else if (e.data === 'CDN_TEST_FAILED') {
            setCookie(Constants.scormCdnTest.COOKIE_NAME, Constants.scormCdnTest.FAILED, { path: '/', maxAge: 60 * 60 * 24 * 7 });
        }
    };

    useEffect(() => {
        window.addEventListener('message', handlerMessage);
        return () => {
            window.removeEventListener('message', handlerMessage);
        };
    }, []);

    return <>{cdnTestUrl && <iframe className={'d-none'} id="scormCDNTest" src={cdnTestUrl} />}</>;
};

export default ScormCDNTest;
